import ContactUsComponents from "../components/ContactUsComponents";

function ContactUs() {
  return (
    <>
      <ContactUsComponents />
    </>
  );
}

export default ContactUs;
